import {serialize, showToast} from "../../helpers/utils/Utils";
import {tgxApi} from "../../app/tgxApi";
import {getAuthorizationHeader, handleQueryError} from "../../helpers/utils/RtkQueryUtils";

const homeApi = tgxApi.injectEndpoints({
    endpoints: (build) => ({

        findOrderCountByStatuses: build.query({
            query: () => {
                return {
                    url: `/ajax/orders-count-by-status`,
                    method: 'GET',
                    headers: getAuthorizationHeader()
                };
            },
            async onQueryStarted(_, {queryFulfilled,}) {
                await handleQueryError(queryFulfilled)
            },
        }),

        getOrderCompletionPercentage: build.query({
            query: () => {
                return {
                    url: `/ajax/orderCompletionStats`,
                    method: 'GET',
                    headers: getAuthorizationHeader()
                };
            },
            async onQueryStarted(_, {queryFulfilled,}) {
                await handleQueryError(queryFulfilled)
            },
        }),

        getOrderBarCharts: build.query({
            query: (data) => {
                let paramData = serialize(data);
                return {
                    url: `/ajax/orders-bar-chart?${paramData}`,
                    method: 'POST',
                    headers: getAuthorizationHeader()
                };
            },
            async onQueryStarted(_, {queryFulfilled,}) {
                await handleQueryError(queryFulfilled)
            },
        }),
    })
})
export const {
    useFindOrderCountByStatusesQuery,
    useGetOrderCompletionPercentageQuery,
} = homeApi;